import type { ToolkitType } from '@viq-admin/types';
import { FPLEADS_DEFAULT_BASE_URL } from './fpleadsCopy';
import { SHOWCARE_DEFAULT_BASE_URL } from './showcareCopy';

/**
 * fpleads and showcare both keep their API address in config.base_url, each
 * with its own default, and antd keeps an unmounted field's value. On a type
 * switch we remember the old type's URL and show the new type's remembered URL
 * (else its default). A URL never crosses vendors: each type's license key or
 * API key must only ever go to its own vendor's host.
 */
const DEFAULT_BASE_URLS: Partial<Record<ToolkitType, string>> = {
  fpleads: FPLEADS_DEFAULT_BASE_URL,
  showcare: SHOWCARE_DEFAULT_BASE_URL,
};

export type BaseUrlMemory = Partial<Record<ToolkitType, string>>;

/**
 * On a type switch: remember the old type's base URL, and return the new type's
 * (its remembered URL, else its default), or null for a type without a base URL.
 * A URL never crosses vendors: each type's license key or API key must only
 * ever go to its own vendor's host.
 */
export function switchBaseUrl(
  memory: BaseUrlMemory,
  from: ToolkitType,
  to: ToolkitType,
  current: unknown,
): string | null {
  if (DEFAULT_BASE_URLS[from] && typeof current === 'string' && current.trim() !== '') memory[from] = current;
  const fallback = DEFAULT_BASE_URLS[to];
  return fallback ? memory[to] ?? fallback : null;
}
